/**
 * Append filters.CREW from a comma-separated page-settings string (exact match tokens).
 */
export function appendCrewCodeToFilters(
  filters: Record<string, unknown>,
  filterCrew: string | null | undefined
): void {
  const raw = String(filterCrew ?? '').trim();
  if (!raw) {return;}
  const crews = raw
    .split(',')
    .map((c) => c.trim())
    .filter((c) => c.length > 0);
  if (crews.length > 0) {
    filters.CREW = crews;
  }
}
